import "./index.scss";
import LogoImg from "../../assets/images/svg/logo-color.svg";
import GridImg from "../../assets/images/bg-grid.png";
import BottomImg from "../../assets/images/bg-bottom3.png";
import DotsImg from "../../assets/images/bg-bottom2.png";
// import PhoneImg from "../../assets/images/iphone.png";
import PhoneImg2 from "../../assets/images/artup_screen.png";
import AppStoreImg from "../../assets/images/buttons/appstore.svg";
// import CustomButton from "../common/CustomButton";

import React from "react";

const Match = ({ setOpenedModal }) => {
  return (
    <div className="match" id="match">
      <div className="match__top">
        <img src={LogoImg} className={`match__logo`} alt="logo" />
        <h3 className="match__title">MA<span>/</span>ArtUp</h3>
        <h2 className="match__subtitle">Manage, display & showcase your art</h2>
      </div>
      <div className={`match__image-wrapper`}>
        <img
          src={GridImg}
          className={`match__image match__image--grid`}
          alt="grid"
        />
        <img
          src={BottomImg}
          className={`match__image match__image--shapes`}
          alt="bottom"
        />
        <img
          src={DotsImg}
          className={`match__image match__image--dots`}
          alt="dots"
        />
      </div>
      <img
        style={{
          transform: `translateY(${window.innerHeight > window.innerWidth ? '100vh' : '130vh'})`
        }}
        src={PhoneImg2}
        className={`match__image match__image--phone`}
        alt="phone"
      />
      <div className={`match__content`}>
        <div className={`match__background`} />
        <p className={`match__a1 match__text match__text--bottom`}>
          ArtUp is an essential tool for artists, art collectors, interior 
          decorators, designers, and art aficionados. Built for iPhone, this 
          app allows you to manage your art portfolio in a secure place and 
          showcase artworks in stylish interiors through web-based viewing rooms. 
        </p>
        <p
          className={`match__a2 match__text match__text--2nd match__text--bottom`}
        >
          Your art portfolio has never looked better! Add all of your artworks 
          along with their photos and details and showcase them in their real 
          dimensions in stylish interiors. Unique interior renderings have been 
          created exclusively for ArtUp by interior design experts with artists 
          in mind. Artworks are placed anywhere on the wall behind furniture and 
          décor objects to create a photorealistic image. Change wall colours 
          and adjust drop shadows as needed. You can even upload your own photo 
          of an interior space and display your artwork in it. Export your created 
          artwork photos in all the popular social media formats in 4K resolution.
        </p>
        <p
          className={`match__a3 match__text match__text--2nd match__text--bottom`}
        >
          To show your art proposals to potential buyers, use full-screen view on 
          your phone or create viewing rooms with unique URLs to send via email or 
          social networks. Viewers can review your proposed artworks on a 
          responsive landing page and leave their comments and reactions to each 
          one. You can see their feedback instantly in the app and can adjust 
          your offering if needed. 
        </p>
        <div className={`match__toolbar`}>
          <a
            href="https://apps.apple.com/us/app/artup-portfolio-staging/id6444745430"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={AppStoreImg}
              alt="App Store"
              className={`match__toolbar-item`}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Match;
